<template>
  <div class="content">
    <div class="commission">
      <div class="commission-top">
        <div class="commission-head">
          <span>我的佣金</span>
          <span
            style="color: #4fd9d5"
            @click="$router.push({ path: '/txt', query: { i: 3 } })"
            >怎么赚钱？</span
          >
        </div>
        <div class="money">￥{{ allData.price }}</div>
        <div class="withdrawal" @click="$router.push({ path: '/chshout' })">
          提现
        </div>
      </div>
      <div class="commission-bottom">
        <div class="commission-bottom-item">
          <span>今日销售额</span>
          <span class="money">￥{{ allData.dayPrice }}</span>
        </div>
        <div class="commission-bottom-line"></div>
        <div class="commission-bottom-item">
          <span>总获得佣金</span>
          <span class="money">￥{{ allData.price }}</span>
        </div>
        <div
          class="commission-bottom-item"
          @click="$router.push({ path: '/yj', query: { t: 1 } })"
        >
          <div class="btn">收益明细</div>
        </div>
      </div>
    </div>

    <div class="qr" @click="popShow = true">
      <i class="iconfont icon-erweima"></i>
      <span>生成专属二维码 </span>
      <i class="iconfont icon-a-LeftArrow"></i>
    </div>
    <div class="mask" @click.stop="popShow = false" v-if="popShow">
      <img :src="allData.qrcode" alt="" srcset="" />
    </div>
    <div class="mode-title">
      <div class="mode-title-line"></div>
      <p>海报分享<span>保存海报到相册分享给好友吧</span></p>
    </div>
    <div class="post-box">
      <div
        class="post"
        v-for="(item, index) in allData.posterList"
        :key="index"
      >
        <a :href="item">
          <div
            :style="'background-image:url(' + item + ')'"
            class="post-item"
          ></div>
          <div class="post-content">可以测运势咨询平台</div>
        </a>
      </div>
    </div>

    <!-- <div class="poster">
      <div class="item">
        <img :src="allData.qrcode" alt="" srcset="">
      </div>
    </div> -->
  </div>
</template>

<script>
/**
@description:推广
@createTime:2021-09-02
@create:wq
*/
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      allData: {},
      popShow: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.extension();
  },
  methods: {
    extension() {
      this.api.extension().then((res) => {
        // console.log(JSON.stringify(res.data));
        this.allData = res.data;
      });
    },
  },
  // 在创建之前，添加body的style属性， 单独设置背景色
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#F5F5F5");
  },
  // 在销毁前，将body的style属性删除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 0.24rem;
  padding-top: 0.24rem;
  background: #f5f5f5;
}
.commission {
  box-shadow: 0px 3px 6px rgba($color: #7b7b7b, $alpha: 0.16);
  border-radius: 0.2rem;
  overflow: hidden;
  background-color: #ffffff;
  .commission-top {
    height: 2.5rem;
    padding: 0.12rem 0.24rem;
    box-sizing: border-box;
    border-bottom: 1px solid #f5f5f5;
    .commission-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.24rem;
      font-weight: 400;
    }
    .money {
      font-size: 0.48rem;
      font-weight: bold;
      color: #666666;
      text-align: center;
      margin-top: 0.34rem;
    }
    .withdrawal {
      margin: 0 auto;
      margin-top: 0.14rem;

      width: 2.8rem;
      height: 0.56rem;
      border-radius: 0.4rem;
      background-color: #4fd9d5;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.24rem;
    }
  }
  .commission-bottom {
    display: flex;
    align-items: center;
    height: 1.4rem;
    .commission-bottom-item {
      flex: 1;

      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .money {
        font-size: 0.32rem;
        font-weight: bold;
        color: #666666;
      }
      .btn {
        align-self: flex-end;
        width: 1.8rem;
        height: 0.7rem;
        border-radius: 0.36rem 0 0 0.36rem;
        border: 1px solid #4fd9d5;
        background-color: #edfbfb;
        font-size: 0.24rem;
        font-weight: 400;
        color: #4fd9d5;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .commission-bottom-line {
      width: 1px;
      height: 0.38rem;
      background-color: #e6e6e6;
    }
  }
}

.qr {
  height: 0.88rem;
  background: #ffffff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
  border-radius: 0.16rem;
  display: flex;
  align-items: center;
  padding: 0 0.26rem 0 0.32rem;
  margin: 0.4rem 0;

  span {
    flex: 1;
    font-size: 0.28rem;
    font-weight: 400;
    color: #666666;
    margin-left: 0.26rem;
  }
  .icon-erweima {
    width: 0.34rem;
    color: #4fd96f;
  }
  .icon-a-LeftArrow {
    color: #cccccc;
    font-size: 12px;
  }
}
.mode-title {
  display: flex;
  margin-bottom: 0.2rem;
  .mode-title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 2px 2px 0px;
    margin-right: 0.16rem;
  }
  p {
    font-size: 0.32rem;
    font-weight: 400;
    color: #666666;
    span {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin: 0 3px;
    }
  }
}
.poster {
  display: flex;
  justify-content: space-between;
  margin-top: 0.22rem;
  .item {
    width: 3.46rem;
    height: 3.94rem;
    background-color: #ffffff;
    border-radius: 0.2rem;
  }
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
  background: rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}
.post-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .post {
    margin-bottom: 0.2rem;
    width: 48%;
    border-radius: 0.1rem;
    overflow: hidden;
    .post-item {
      height: 3.28rem;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .post-content {
      background: #fff;
      height: 0.66rem;
      font-size: 0.24rem;
      color: #999999;
      line-height: 0.66rem;
      padding-left: 0.1rem;
    }
  }
}
</style>
